import { render, staticRenderFns } from "./DevDebug.vue?vue&type=template&id=52395a2c&scoped=true"
import script from "./DevDebug.vue?vue&type=script&lang=js"
export * from "./DevDebug.vue?vue&type=script&lang=js"
import style0 from "./DevDebug.vue?vue&type=style&index=0&id=52395a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52395a2c",
  null
  
)

export default component.exports